module.exports = __webpack_public_path__ + "static/img/p4.e71832de.png";